import { render, staticRenderFns } from "./UpcomingMeetings.vue?vue&type=template&id=60cef5e6&scoped=true&"
import script from "./UpcomingMeetings.vue?vue&type=script&lang=js&"
export * from "./UpcomingMeetings.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingMeetings.vue?vue&type=style&index=0&id=60cef5e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cef5e6",
  null
  
)

export default component.exports